//SLVI-827-FIX-IDOR INICIO 
const SECRET = process.env.REACT_APP_CRYPTO_KEY;

const dataConverter = {
  toBase64: (str) => {
    try {
      let result = '';
      for (let i = 0; i < str.length; i++) {
        result += String.fromCharCode(
          str.charCodeAt(i) ^ SECRET.charCodeAt(i % SECRET.length)
        );
      }
      return btoa(result);
    } catch (error) {
      console.error('Erro ao criptografar:', error);
      return '';
    }
  },
  fromBase64: (encoded) => {
    try {
      const str = atob(encoded);
      let result = '';
      for (let i = 0; i < str.length; i++) {
        result += String.fromCharCode(
          str.charCodeAt(i) ^ SECRET.charCodeAt(i % SECRET.length)
        );
      }
      return result;
    } catch (error) {
      console.error('Erro ao descriptografar:', error);
      return '';
    }
  }
};

export default dataConverter;
//SLVI-827-FIX-IDOR FIM
